import { render, staticRenderFns } from "./jurisdiction.vue?vue&type=template&id=1ea9164c&scoped=true"
import script from "./jurisdiction.vue?vue&type=script&lang=js"
export * from "./jurisdiction.vue?vue&type=script&lang=js"
import style0 from "./jurisdiction.vue?vue&type=style&index=0&id=1ea9164c&scoped=true&lang=scss"
import style1 from "./jurisdiction.vue?vue&type=style&index=1&id=1ea9164c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea9164c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea9164c')) {
      api.createRecord('1ea9164c', component.options)
    } else {
      api.reload('1ea9164c', component.options)
    }
    module.hot.accept("./jurisdiction.vue?vue&type=template&id=1ea9164c&scoped=true", function () {
      api.rerender('1ea9164c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/jurisdiction/jurisdiction.vue"
export default component.exports